module.exports = __webpack_public_path__ + "static/Panasonic Business 2 Lines (Transparent)-e170d25746a520e56cb9376afcdeda18.png";